const work = [
  {
    title: "Free-CV",
    id: 1,
    src: "./Ux Design/freecv.png",
    href: "https://free-cv.vercel.app/",
    desc: "A Full-stack web application for creating CV.",
    github: "https://github.com/Akshit3010/cv-maker",
    offset: -150,
    tech: "NextJs | Redux | Tailwind | NestJs | MongoDB | Firebase | Framer Motion",
  },
  {
    title: "Bewakoof Website Clone",
    id: 2,
    src: "./Ux Design/Bewakoof.jpg",
    href: "https://heady-rabbits-8957.vercel.app/",
    desc: "A Full-stack web application for buying clothes and accessories.",
    github: "https://github.com/Akshit3010/heady-rabbits-8957",
    offset: -150,
    tech: "ReactJs | Redux | Tailwind | ExpressJs | MongoDB",
  },
  {
    title: "Blogshog",
    id: 3,
    src: "./Ux Design/Blogshog1.png",
    href: "https://blogshog.vercel.app/",
    desc: "Blogshog is a full-stack web application that lets you browse, write, and comment on other blogs.",
    github: "https://github.com/Akshit3010/Full-stack-blog-application",
    offset: 600,
    tech: "ReactJs | Redux | Tailwind | ExpressJs | MongoDB",
  },
  {
    title: "Rodan+Fields Website Clone",
    id: 4,
    src: "./Ux Design/Rodan.png",
    href: "https://rodanfields.netlify.app/",
    desc: "A web application to buy skincare and beauty products.",
    github: "https://github.com/Akshit3010/Rodanandfields",
    offset: -150,
    tech: "HTML | CSS | javaScript",
  },
  {
    title: "Lyst Website Clone",
    id: 5,
    src: "./Ux Design/Lyst.jpg",
    href: "https://lyst-clone.netlify.app/",
    desc: "A web application to buy Men and Women's Fashion Accessories.",
    github: "https://github.com/Akshit3010/Lyst-clone",
    offset: 600,
    tech: "Reactjs | Redux | Tailwind",
  },
  {
    title: "Cultfit Website Clone",
    id: 6,
    src: "./Ux Design/Cultfit.jpg",
    href: "https://cultfit-demo.netlify.app/",
    desc: "Fitness Website",
    github: "https://github.com/Akshit3010/Cult-Fit-clone",
    offset: -150,
    tech: "HTML | CSS | javaScript",
  },

  {
    title: "Movie Search App",
    id: 7,
    src: "./Ux Design/Movieapp.jpg",
    href: "https://hotstar3app.netlify.app/",
    desc: "A movie application to get information about any movie or web-series.",
    github: "https://github.com/Akshit3010/Movie-Search-App",
    offset: 600,
    tech: "HTML | CSS | javaScript",
  },
  {
    title: "City Weather App",
    id: 8,
    src: "./Ux Design/WeatherApp.jpg",
    href: "https://cityweatherapp2.netlify.app/",
    desc: "A website to check weather of any city.",
    github: "https://github.com/Akshit3010/CityWeatherApp",
    offset: -150,
    tech: "HTML | CSS | javaScript",
  },
];

export default work;
